import { setUser as setSentryUser } from '@sentry/react';
import { usePendoAnalytics } from 'hooks/use-pendo-analytics.hook';
import { useEffect } from 'react';
import { initializePendo } from 'utils/pendo';

export const useAnalytics = (): void => {
  const analytics = usePendoAnalytics();

  useEffect(() => {
    if (window.pendo && analytics) {
      initializePendo(window.pendo, analytics);
    }

    // Sentry only indexes a top-level `id` as the searchable user id; without it the uuid stays
    // buried in `visitor` and `user.id:<uuid>` matches nothing.
    setSentryUser(analytics ? { ...analytics, id: analytics.visitor?.id } : null);
  }, [analytics]);
};
